export const DEFAULT_LOGIN_PREFIX = '/login';
